/*
 * Calculates `text` y position based on the height
 * of the text container and its font-size
 *
 * This is needed because we cannot reliably use baseline in all browsers
 */
export default function (fontSize, height) {
  return (height / 2) + (fontSize / 2.7) - 0.3
}
